import React from 'react'

export default function Loader() {
    return (
        <div className="preloader">
            <div className="loader-bg">
                <div className="loader-p"></div>
            </div>
        </div>
    )
}
